import React from 'react';
import moment from 'moment';
import classnames from 'classnames';
import {Link} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';
import {Grid, Button} from 'semantic-ui-react';
import {bool, func, string, number, shape} from 'prop-types';
import {isSponsored, requiresW9AndAffidavit} from 'pages/EditPrize/utils';
import PrizeBreakId from 'components/prizes/PrizeBreakId';
import {formatDate, EmptyFunc} from 'utils/DBUtils';

const dateFormat = 'MM/DD/YY';

const DownloadIcon = () =>  {
  return <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="download" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-download fa-w-16 fa-3x"><path fill="currentColor" d="M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z" class=""></path></svg>
}

const EntriesPageHeader = props => {
  const isSponsoredPrize = isSponsored(props.prize);
  const prizeDashboardRoute = isSponsoredPrize ? '/prizes/sponsored' : '/prizes/editorial';

  const showSelectWinnersButton = isSponsoredPrize || requiresW9AndAffidavit(props.prize);

  const now = moment();
  let autoAwardDate;

  if (props.prize.weeklyWinners) {
    const prevDraws = props.prize.drawInfo.filter(({drawDate}) => moment(drawDate).isBefore(now));
    const nextDraw = props.prize.drawInfo[prevDraws.length];

    if (nextDraw) {
      autoAwardDate = moment(nextDraw.drawDate).valueOf();
    }
  } else {
    autoAwardDate = moment(props.prize.winnerSelectionDate).valueOf();
  }

  const drawDates = (
    <React.Fragment>
      <div>
        <FormattedMessage
          id='entriesList.label.endDate'
          values={{endDate: formatDate(props.prize.endTime, dateFormat)}} />
      </div>
      {showSelectWinnersButton ? null : (
        <div>
          <FormattedMessage
            id='entriesList.label.autoAwardDate'
            values={{autoAwardDate: autoAwardDate ? formatDate(autoAwardDate, dateFormat) : ''}} />
        </div>
      )}
    </React.Fragment>
  );

  return (
    <Grid className='entries-page-header'>
      <Grid.Row>
        <Grid.Column width={2} textAlign='left' verticalAlign='top'>
          <Link to={prizeDashboardRoute}>
            <FormattedMessage id='entriesList.link.goBack' />
          </Link>
        </Grid.Column>
        <Grid.Column width={3} textAlign='left' verticalAlign='top' className='prize-title'>
          <FormattedMessage id='entriesList.label.prize' />
          <Link to={`/prize/${props.prize.id}/edit?openSection=editPrizeSection`}>
            {props.prize.title}
          </Link>
        </Grid.Column>
        <Grid.Column width={4} textAlign='left' verticalAlign='top' className='prize-break-id'>
          {isSponsoredPrize && (
            <React.Fragment>
              <FormattedMessage id='entriesList.label.breakId' />
              <PrizeBreakId
                prize={props.prize}
                onClick={props.openPrizeChallengesModal} />
            </React.Fragment>
          )}
        </Grid.Column>
        <Grid.Column width={2} verticalAlign='middle' className='prize-end-date'>
          {drawDates}
        </Grid.Column>
        <Grid.Column width={2} textAlign='right' verticalAlign='middle'>
          {isSponsoredPrize && (
            <FormattedMessage
              id='entriesList.label.winnersRequired'
              values={{numToAward: props.prize.numToAward}} />
          )}
        </Grid.Column>
        <Grid.Column width={3} textAlign='right' verticalAlign='middle'>
            <Button onClick={props.downloadReport} style={{padding: '10px', width: '34px'}}>
              <DownloadIcon/>
            </Button>
              
            <Button onClick={props.startManualEntry}>
                <FormattedMessage id='entriesList.button.manualEntry' />
            </Button>
          {showSelectWinnersButton && (
            <Button
              className={classnames('select-winners-button', {disabled: !props.allowSelectWinners})}
              onClick={props.allowSelectWinners ? props.selectWinners : EmptyFunc}
              loading={props.selectingWinners}
              disabled={!props.allowSelectWinners}>
              <FormattedMessage id='entriesList.button.selectWinners' />
            </Button>
          )}
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

EntriesPageHeader.propTypes = {
  prize: shape({
    id: string,
    title: string,
    numToAward: number
  }),
  allowSelectWinners: bool,
  selectWinners: func.isRequired,
  openPrizeChallengesModal: func.isRequired,
  downloadReport: func.isRequired
};

EntriesPageHeader.defaultProps = {
  prize: {
    id: '',
    title: '',
    numToAward: 0
  },
  allowSelectWinners: false,
  selectWinners: EmptyFunc,
  openPrizeChallengesModal: EmptyFunc
};

export default EntriesPageHeader;



// WEBPACK FOOTER //
// ./public/pages/ListEntries/EntriesPageHeader.jsx